import {
  ResidualValue,
  ResidualValueEditFormValues,
  ResidualValueRow,
  ResidualValueTableEditFormValues,
  ResidualValueTable,
  ResidualValueTableValue,
} from "./types";

/*---------------------------------------------------------------------------------------
  CALCULATION RESIDUAL VALUE 
-----------------------------------------------------------------------------------------*/

export const transformResidualValue = (res: any): ResidualValue => {
  return {
    id: res.id,
    name: res.name,
  };
};

/*---------------------------------------------------------------------------------------
  CALCULATION RESIDUAL VALUE SEARCH
-----------------------------------------------------------------------------------------*/

export const transformResidualValueRow = (res: any): ResidualValueRow => {
  return {
    id: res.id,
    name: res.name,
  };
};

/*---------------------------------------------------------------------------------------
    CALCULATION RESIDUAL VALUE CREATE
  -----------------------------------------------------------------------------------------*/

export const transformResidualValueOnCreate = (
  formValues: ResidualValueEditFormValues
): any => ({
  name: formValues.name,
});

/*---------------------------------------------------------------------------------------
  CALCULATION RESIDUAL VALUE EDIT
-----------------------------------------------------------------------------------------*/

export const transformResidualValueOnUpdate = (
  formValues: ResidualValueEditFormValues
): any => ({
  id: formValues.id,
  name: formValues.name,
});

/*---------------------------------------------------------------------------------------
  CALCULATION RESIDUAL VALUE EDIT
-----------------------------------------------------------------------------------------*/

export const transformResidualValueTableOnUpdate = (
  formValues: ResidualValueTableEditFormValues
): any => ({
  residualValueKmId: formValues.residualValueKmId,
  residualValueMonthId: formValues.residualValueMonthId,
  percentage: formValues.percentage,
});

export const transformResidualValueTable = (res: any): ResidualValueTable => {
  return {
    id: res.id,
    name: res.name,
    months: res.months,
    kms: res.kms,
    values: res.values,
  };
};

export const transformResidualValueTableValue = (
  kmId: string,
  monthId: string,
  values: ResidualValueTableValue[]
): number => {
  // Find the entry in the values array where both kmId and monthId match
  const entry = values.find((v) => v.km.id === kmId && v.month.id === monthId);

  // If no matching entry is found, return 0 or handle as needed
  if (!entry) {
    return 0;
  }

  // Return the percentage value from the found entry
  return entry.percentage;
};
